<template>
  <div>
    <section class="sectionStyle" style="background-color: #e5ebff;padding:80px 0 120px 0;">
      <div class="GS_JJ_content_box">
        <div class="ck_header">
          <a-row class="GS_JJ_content_box "  type="flex" justify="space-between">
            <a-col :xs="24" :sm="24" :md="24" :lg="20" class="animate__animated animate__fadeInLeftBig wow">
              <p class="modular_title">荣誉墙 <span style="font-size:32px;font-weight:400">Honor Board</span> </p>
            </a-col>
            <a-col :xs="24" :sm="24" class="fixed-width-md">
              <div class="swiperButton">
                <div class="swiper-button-prev swiper-button-white swiper-button-prev-ry" slot="button-prev"><a-icon type="left" /></div>
                <div class="swiper-button-next swiper-button-white swiper-button-next-ry" slot="button-next"><a-icon type="right" /></div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <swiper ref="mySwiperKc" :options="swiperOptionsry" style="min-height: 440px;" class="swiper-wrappe carousel">
            <swiper-slide class="swiper-slide"  v-for="(b,i) in headerBannerList" :key="`${i}-${b.img}`">
                <div class="ry_list_box_copy" @click.stop="openLink(b), $event.stopPropagation();">
                  <div class="ry_img_box">
                      <img :src="b.img" alt="">
                  </div>
                  <div class="content-area">
                    <div class="ry_name">{{b.oneText}}</div>
                    <div class="ry_time">
                      <p>{{b.twoText}}</p>
                      <div class="link_a iconfont" >&#xe612;</div>
                    </div>
                  </div>
                </div>
            </swiper-slide>
      </swiper>
    </section>
  </div>
</template>
<script>
export default {
  props:[],
  watch:{},
  name: '',
  components: {},
  data() {
    return {
      // 我们的荣誉
      swiperOptionsry:{
        autoplay:true,
        speed: 800,
        observer: true,
        observeParents: true,
        slidesPerView: 5, // 大于900像素时显示3个幻灯片
        spaceBetween: 20,  // 可选：设置间距
        touchRatio: 1, // 确保触摸交互正常
        simulateTouch: true, // 允许模拟触摸
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next-ry",
          prevEl: ".swiper-button-prev-ry",
        },
        loop: false,
        breakpoints: {
          1500:{
            slidesPerView: 4,
            spaceBetween: 20
          },
          1200:{
            slidesPerView: 3,
            spaceBetween: 20
          },
          920: {  //当屏幕宽度小于等于1280
            slidesPerView: 3,
            spaceBetween: 20
          },
          768: {  //当屏幕宽度小于等于768
            slidesPerView: 2,
            spaceBetween: 20,
          },
           500: {  //当屏幕宽度小于等于768
            slidesPerView: 1,
            spaceBetween: 20,
          },
        } 
      },
      headerBannerList:[]
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    if (this.tenantConfig && this.tenantConfig.cert) {
      var certImages = this.tenantConfig.cert.split(",");
      if(this.tenantConfig.certOneText){
        var certOneText = this.tenantConfig.certOneText.split("\n")
      }else{
        var certOneText = []
      }
      if(this.tenantConfig.certTwoText){
        var certTwoText = this.tenantConfig.certTwoText.split("\n")
      }else{
        var certTwoText = []
      }
      if(this.tenantConfig.certLinks){
        var certLinks = this.tenantConfig.certLinks.split("\n")
      }else{
        var certLinks = []
      }
      for (var i in certImages) {
        var b = {};
        b.img = certImages[i];
        if(certOneText.length>i){
          b.oneText = certOneText[i]
        }
        if(certTwoText.length > i){
          b.twoText = certTwoText[i]
        }if(certLinks.length > i){
          b.link = certLinks[i]
        }
        this.headerBannerList.push(b);
      }
    }
  },
  mounted() {},
  methods: {
    openLink(row){
      if(row.link) window.open(row.link,'_blank')
      
    }
  }
}
</script>
<style lang='less' scoped>
.modular_title{
  width: 100%;
  text-align: left;
  font-weight: 600;
  font-size: 48px;
  color: #000000;
  line-height: 75px;
}
.modular_tips{
  width: 80%;
  margin: 17px auto;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0,0,0,0.58);
  line-height: 19px;
  text-align: center;
}
.ry_list_box_copy{
  width: 100%;
  min-height: 470px;
  height: auto;
  background: #fff;
  padding: 45px 40px 20px 40px;
  border-radius: 8px;
  color: #000000;

  .ry_img_box{
    width: 100%;
    height: 310px;
    img{
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
  .content-area{
    width: 100%;
    padding: 25px 0 0 0;
    .ry_name{
      font-weight: 600;
      font-size: 16px;
      line-height: 25px;
    }
    .ry_time{
      font-weight: 600;
      font-size: 16px;
      line-height: 25px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .link_a{
        width: 60px;
        height: 26px;
        border-radius: 13px;
        border: 1px solid #000;
        line-height: 25px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.ry_list_box_copy:hover{
  background: #0039C8;
  color: #fff;
}
.ry_list_box_copy:hover .link_a{
  border-color: #fff !important;
}
.swiper-button-prev-ry , .swiper-button-next-ry{
  color: #0039C8;
  border-color: #0039C8;
  opacity: 1 !important;
}
</style>
